import { useEffect } from 'react';
import { Button, Text } from '@mercator-gcp/grout';
import { useNavigate } from 'react-router-dom';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import BasePageWithTopNav from 'components/layout/TopNavigationLayout';
import PageMetadata from 'components/PageMetadata';
import { useAuth } from 'hooks/useAuth';
import { useUser } from 'state/auth';
import { useEmailQuery } from 'state/queryParams';
import { trackPageView } from 'utils/analytics';

const container = {
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  gap: 'padding_16',
  textAlign: 'center',
};
const contentColumn = {
  gap: '40px',
  justifyContent: 'center',
  alignItems: 'center',
};

const EmailVerifiedConfirmation = () => {
  const navigate = useNavigate();
  const emailQuery = useEmailQuery();
  const { user } = useUser();
  const { logout } = useAuth();

  useEffect(() => {
    trackPageView({ sectionName: 'sign_up', subSectionName: 'sign_up_verify_email' });
  }, []);

  const handleVerificationRedirect = () => {
    if (emailQuery !== user?.email) {
      logout();
    } else {
      navigate('/login');
    }
  };

  return (
    <BasePageWithTopNav>
      <PageMetadata title="Email Verified" />
      <FlexColumn sx={container}>
        <Text.H3>Your email {emailQuery} was successfully verified</Text.H3>
        <FlexColumn sx={contentColumn}>
          <Text>You may close this window</Text>
          <Button variant="primary" onClick={handleVerificationRedirect}>
            Continue to login
          </Button>
        </FlexColumn>
      </FlexColumn>
    </BasePageWithTopNav>
  );
};

export default EmailVerifiedConfirmation;
